import { RecentPacketItem } from './RecentPacketItem';
import { useRecentPackets } from '../hooks/useRecentPackets';
import { Skeleton } from '@/components/ui/skeleton';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

export function RecentPacketList() {
  const { data: packets, isLoading, error } = useRecentPackets();

  if (isLoading) {
    return (
      <div className="space-y-2">
        {[...Array(3)].map((_, index) => (
          <div key={index} className="flex items-center justify-between p-3">
            <div className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 rounded-full" />
              <div className="space-y-1">
                <Skeleton className="h-4 w-[150px]" />
                <Skeleton className="h-3 w-[100px]" />
              </div>
            </div>
            <Skeleton className="h-4 w-[80px]" />
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Error Loading Recent Packets</AlertTitle>
        <AlertDescription>
          {error.message || 'Could not fetch recent packets. Please try again later.'}
        </AlertDescription>
      </Alert>
    );
  }

  if (!packets || packets.length === 0) {
    return (
      <div className="border-dashed border-border p-8 text-center text-muted-foreground rounded-md">
        No recent packets found.
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      {packets.map((packet, index) => (
        <RecentPacketItem key={packet.id} packet={packet} index={index} />
      ))}
    </div>
  );
} 